export default __webpack_public_path__ + "static/media/fragment_of_decarabians_epic.8503f1bf.png";